import { sanitizeHtml } from '@intercom/pulse/lib/sanitize';
const Templater = function ($composer) {
  this.$composer = $composer;
  this._setup();
};
Templater.prototype.applyTemplate = function (transformedTemplate, isReadonly) {
  if (!this.$composer) {
    return;
  }
  this._setup(isReadonly);
  this._setTemplateContainerContents(transformedTemplate);
  this._wrapEditorInTemplate();
  this._attachWidgetsComponents();
};
Templater.prototype.removeTemplate = function () {
  this._restoreEditor();
  this._restoreAttachmentList();
  this._restoreWidgets();
  this._clearTemplateContainer();
};
Templater.prototype.destroy = function () {
  this.$templateContainer = null;
  this.$editor = null;
  this.$attachmentList = null;
  this.$composer = null;
  this.$composerBox = null;
  this.$readonlyContainer = null;
};
Templater.prototype._setup = function (isReadonly) {
  this.$templateContainer = this.$composer.find('.composer-template-container');
  this.isReadonly = isReadonly;
  if (isReadonly) {
    this.$editor = this.$composer.find('#composer-read-only-content');
    this.$readonlyContainer = this.$composer.find('#composer-read-only-content-container');
    this.$attachmentList = this.$composer.find('#composer-read-only-content-container .attachment-list-container');
  } else {
    this.$editor = this.$composer.find('.embercom-composer-editor:not(#composer-read-only-content)');
    this.$readonlyContainer = null;
    this.$attachmentList = this.$composer.find('.composer-box .attachment-list-container');
  }
  this.$composerBox = this.$composer.find('.composer-box');
  this.$widgetContainer = this.$composer.find('.widget-container');
};
Templater.prototype._wrapEditorInTemplate = function () {
  let contentNode = this._findContentNode();
  /* @pat - This lint rule is okay to disable as we are just moving elements around */
  /* eslint-disable-next-line jquery-unsafe/no-append, jquery-unsafe/no-html */
  contentNode.html(this.$editor).append(this.$attachmentList);
};
Templater.prototype._restoreEditor = function () {
  let $originalContainer = this.isReadonly ? this.$readonlyContainer : this.$composerBox;
  if ($originalContainer.children().length === 0) {
    /* @pat - This lint rule is okay to disable as we are just moving elements around */
    /* eslint-disable-next-line jquery-unsafe/no-append, jquery-unsafe/no-html */
    $originalContainer.html(this.$editor).append(this.$attachmentList);
  }
};
Templater.prototype._restoreAttachmentList = function () {
  let $originalContainer = this.isReadonly ? this.$readonlyContainer : this.$composerBox;
  if ($originalContainer.find('.attachment-list-container').length === 0) {
    /* @pat - This lint rule is okay to disable as we are just moving elements around */
    /* eslint-disable-next-line jquery-unsafe/no-append */
    $originalContainer.append(this.$attachmentList);
  }
};
Templater.prototype._restoreWidgets = function () {
  /* @pat - This lint rule is okay to disable as we are just moving elements around */
  /* eslint-disable-next-line jquery-unsafe/no-html */
  this.$widgetContainer.html(this._findWidgetComponents());
};
Templater.prototype._attachWidgetsComponents = function () {
  let self = this;
  let widgetComponents = this._findWidgetComponents();
  widgetComponents.each(function () {
    let widgetName = this.dataset['widgetName'];
    /* @pat - This lint rule is okay to disable as we are just moving elements around */
    /* eslint-disable-next-line jquery-unsafe/no-html */
    self._findWidgetNode(widgetName).html(this);
  });
};
Templater.prototype._setTemplateContainerContents = function (transformedTemplate) {
  this.$templateContainer.html(sanitizeHtml(transformedTemplate).string);
};
Templater.prototype._clearTemplateContainer = function () {
  this.$templateContainer.html('');
};
Templater.prototype._findContentNode = function () {
  return this.$templateContainer.find('#composer-content');
};
Templater.prototype._findWidgetNode = function (name) {
  return this.$templateContainer.find(`.customisable-widget.${name}`);
};
Templater.prototype._findWidgetComponents = function () {
  return this.$composer.find('.widget-component');
};
export default Templater;